import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type IntentionData = PildomModules.Voirie.Data.IntentionData

export class Intention extends BaseModel<IntentionData> {
    endPoint: string = 'voirie/intentions'
    translationKey: string = 'voirie.intentions'
    permissionName: string = 'voirie_intention'
    legendPictoUrl: string = 'voirie/map-legend/intentions.png'
}
